module.exports = __webpack_public_path__ + "static/media/plus-circle.afa33075.svg";